import { render, staticRenderFns } from "./imageController.vue?vue&type=template&id=592e80c8&"
import script from "./imageController.vue?vue&type=script&lang=ts&"
export * from "./imageController.vue?vue&type=script&lang=ts&"
import style0 from "./imageController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports